module.exports = __webpack_public_path__ + "images/emoji/whale2.3fe709b52f0e866a274a.png";